"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.falseCV = exports.trueCV = void 0;
const clarityValue_1 = require("../clarityValue");
const trueCV = () => ({ type: clarityValue_1.ClarityType.BoolTrue });
exports.trueCV = trueCV;
const falseCV = () => ({ type: clarityValue_1.ClarityType.BoolFalse });
exports.falseCV = falseCV;
//# sourceMappingURL=booleanCV.js.map